import React from 'react';

interface HorizontalScrollProps {
  children: React.ReactNode;
}

/**
 * Lets a wide control (e.g. a period Segmented) scroll sideways on phones instead of
 * overflowing the page; the scrollbar is hidden so it does not look like a stray line.
 */
export function HorizontalScroll({ children }: HorizontalScrollProps) {
  return <div style={{ maxWidth: '100%', overflowX: 'auto', scrollbarWidth: 'none' }}>{children}</div>;
}

export default HorizontalScroll;
